import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "http://127.0.0.1:8000/api",
});

// ── CONTEXT AUTH ──
// Token ab localStorage se nahi aata. AppContext jab bhi authToken
// change karta hai, woh setAxiosAuthToken() call karke yeh module-level
// variable update karta hai. Refresh hone par yeh reset ho jata hai
// (kyunki module bhi dobara load hota hai) — by design.
let currentToken = "";

export const setAxiosAuthToken = (token) => {
  currentToken = token || "";
};

axiosInstance.interceptors.request.use((config) => {
  if (currentToken) {
    config.headers.Authorization = `Bearer ${currentToken}`;
  }
  return config;
});

export default axiosInstance;